var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"pa-2",staticStyle:{"width":"100%","max-width":"1000px"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }